import moment from "moment";

/**
 * Format date and time string string for table cells
 * @param {string} cell iso format date string
 */
export function dateAndTimeFormatter(cell) {
  return cell ? moment(cell).format("MMM D, YYYY - HH:mm") : "";
}
